module.exports = __webpack_public_path__ + "static/media/img4_1.3b808d42.png";